import React from "react";
import RichText from "../RichText/RichText";
import "./IconTextRow.css";

const IconTextRow = ({ icon, text, alt = "" }) => {
    if (!icon || !text) {
        return null;
    }

    return (
        <div className="IconTextRow">
            <img
                className="IconTextRow__icon"
                src={icon}
                alt={alt}
                draggable={false}
            />
            <div className="IconTextRow__text">
                <RichText text={text} />
            </div>
        </div>
    );
};

export default IconTextRow;
